import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";

import { HalfYearContext } from "../../../contexts/halfYearContext";

import MainButton from "../../common/MainButton";
import DataTable from "./SectionSalaryList";
import MainTitle from "../../common/MainTitle";

import TableMainSearch from "../../common/MainSearch";

const SectionSalary = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");
  const { halfYear } = useContext(HalfYearContext);

  useEffect(async () => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { sid } = props.match.params;
      const { halfYear } = p;

      let query = `expenses/salary/sections/${sid}?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content"></div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} query={query} />
      </div>
    </div>
  );
};

export default SectionSalary;
